export default function BotonDivL({ tituloBoton, onClick }) {
  return (
    <div onClick={onClick} className="botonCardL">
      {tituloBoton}
    </div>
  );
}
